import React, { useState } from 'react';
import Categorys from './Categorys';
import Menu from './Menu';
import menu from './menudata';
import '../all.css'


const allCategory = ['all', ...new Set(menu.map((item) => item.category))]
const MenuSetup = () => {


  const [menuItems, setMenuItems] = useState(menu)
  const [category, setCategory] = useState(allCategory)


  const filterItems = (category) => {
    if (category === 'all') {
      setMenuItems(menu)
      return
    }
    const newItems = menu.filter((item) => item.category === category)
    console.log(newItems);
    setMenuItems(newItems)
  }
 
  return (
    <main>
      <section className="menu section">
        <div className="title">
          <h2>our menu   </h2>
          <div className="underlines"></div>
        </div>
        <Categorys category={category} filterItems={filterItems} />
        <Menu menu={menuItems} />
      
      </section>
    </main>
  );
};

export default MenuSetup;